import styled from 'styled-components/macro';
import { fonts, mediaQuery, grid } from '@noths/styles-config';
import { colour } from '@notonthehighstreet/toolkit/utils';
import * as Form from '../../components/V2/Form';

export const Red = styled.span({
  color: 'red',
});

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${fonts.family.v3};
  ${mediaQuery('tablet desktop')} {
    margin-top: 16px;
    margin-bottom: 32px;
  }
`;

export const Blurb = styled.div({
  textAlign: 'justify',
  fontSize: fonts.size.s,
});

export const PrivacyPolicyLink = styled.a({
  textDecoration: 'none',
  color: colour('blue-chill'),
});

export const formNameFirst = styled.label({});

export const ButtonContainer = styled.div({
  width: '100%',
  padding: `${grid * 2}px 0`,
  [mediaQuery('tablet desktop')]: {
    textAlign: 'right',
    width: 'auto',
  },
});

export const ReCaptchaContainer = styled.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '0 0 20px 0',
});

export const Name = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${mediaQuery('tablet desktop')} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;

const NameInputContainer = styled(Form.InputContainer)`
  width: 100%;
  ${mediaQuery('tablet desktop')} {
    width: 50%;
    & + & {
      margin-left: 20px;
    }
  }
`;

export const FirstName = NameInputContainer;
export const LastName = NameInputContainer;

export const MarketingPreferences = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  margin: '20px 0',
});

export const Preferences = styled.div({
  marginTop: '20px',
});
